<template>
    <v-timeline-item
            fill-dot
            :icon="item.psychological_record && item.psychological_record.session_number > 0 ? 'fa-search' : 'fa-calendar-alt'"
            :class="[{'indent': item.psychological_record && item.psychological_record.session_number > 0}]"
            :color="currentEvent && item.id === currentEvent.id ? 'accent' : (!item.psychological_record || item.psychological_record.session_number === 0 ? 'secondary' : 'primary')"
            :large="!item.psychological_record || item.psychological_record.session_number === 0"
    >
        <v-card flat :color="!item.psychological_record || item.psychological_record.session_number === 0 ? 'grey lighten-3' : 'grey lighten-2'" :hover="canWatch" @click="canWatch ? $emit('click', item.id) : () => {}">
            <v-card-title class="dark py-1">
                <div >
                    <span class="font-weight-bold">{{item.human_date_time.toUpperCase()}}</span>
                    <v-chip small>
                        <v-icon left class="mr-2" size="16">fa-clock</v-icon>
                        {{item.time}}
                    </v-chip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-avatar v-on="on" size="25" color="grey darken-2" >
                                <v-icon size="14" dark  >{{item.sub_type_icon}}</v-icon>
                            </v-avatar>
                        </template>
                        <span>{{item.sub_type_description}}</span>
                    </v-tooltip>


                    <v-chip v-if="!!item.session_name" small :color="item.session_color" dark>
                        <v-icon  class="mr-2" size="16">fa-calendar-check</v-icon>
                        {{item.session_name}}
                    </v-chip>

                    <v-chip v-if="item.discharge" small color="success" dark>
                        <v-icon left class="mr-2" size="16">fa-check-circle</v-icon>
                        Alta
                    </v-chip>


                </div>
            </v-card-title>

            <v-card-text v-if="item.relationship" class="py-1">
                Como <span class="font-weight-bold">{{item.relationship.toLowerCase()}}</span> de <b>{{item.client.first_name}} {{item.client.last_name}}</b>
            </v-card-text>

            <v-card-text class="py-1">
                Atendido por: <span class="font-weight-bold">{{item.schedule.specialist.first_name}} {{item.schedule.specialist.last_name}}</span>
            </v-card-text>

            <div class="pa-2" v-if="canWatch">
                <v-sheet class="pa-2" v-if="item.anamnesis" color="grey lighten-2">

                    <template v-if="item.anamnesis.symptoms && item.anamnesis.symptoms.length > 0">
                        <div class="font-weight-bold mt-1">Síntomas:</div>
                        <div class="section py-1 pl-2 " >
                            <template v-for="symptom in item.anamnesis.symptoms">
                                <div class="body-1 ml-1" :key="symptom.id"> - {{symptom.description}}, durante {{symptom.duration}} {{symptom.duration_unit}}<template v-if="symptom.eye">, ojo: {{symptom.eye}}</template>.</div>
                            </template>
                        </div>
                    </template>

                    <template v-if="item.anamnesis.anamnesis_options && item.anamnesis.anamnesis_options.length > 0">
                        <div class="font-weight-bold mt-1">Observaciones:</div>
                        <div class="section py-1 pl-2" >
                            <template v-for="option in item.anamnesis.anamnesis_options">
                                <div class="body-1 ml-1" :key="option.id"> - {{option.description}}.</div>
                            </template>
                        </div>
                    </template>

                    <template v-if="item.anamnesis.comment">
                        <div class="font-weight-bold mt-1">Comentarios:</div>
                        <div class="section py-1 pl-2 ">
                            {{item.anamnesis.comment}}
                        </div>
                    </template>

                    <template v-if="item.diagnoses && item.diagnoses.length > 0">
                        <div class="font-weight-bold mt-1">Diagnóstico:</div>
                        <div class="section py-1 pl-2 " >
                            <template v-for="diagnosis in item.diagnoses">
                                <div class="body-1 ml-1" :key="diagnosis.id"> - {{diagnosis.name}}.</div>
                            </template>
                        </div>
                    </template>

                </v-sheet>
            </div>
            <div v-else class="pa-2">
                <v-layout pa-3 wrap justify-center align-center class="grey lighten-2">
                    <v-flex xs12 text-xs-center>
                        <v-icon color="grey">fa-lock</v-icon>
                    </v-flex>
                    <v-flex xs12 text-xs-center>
                        <div class="subtitle">Contenido bloqueado</div>
                        <div class="caption">No estas autorizado(a) para ver los detalles de la cita</div>
                    </v-flex>
                </v-layout>
            </div>

        </v-card>
        <v-divider></v-divider>
    </v-timeline-item>
</template>

<script>

    import {mapState} from 'vuex'

    export default {
        name: "ClientAttentionHistoryItem",
        props:{
            item: {
                type: Object,
                required: true
            }
        },
        computed:{
            ...mapState('clientAttention', {
                currentEvent: state => state.currentEvent
            }),
            canWatch(){

                const vm = this

                return true

               /* if(!vm.userIsTechnologist && !vm.userIsSpecialist){
                    return false
                }

                if(vm.userIsSpecialist){
                    return vm.currentUser.id === vm.item.schedule.specialist.id
                }

                return true*/

            },
        }
    }
</script>

<style scoped>

</style>